var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"12"}},[_c('v-img',{attrs:{"aspect-ratio":"1","contain":"","src":require("@/assets/contrato_flexmulti.jpg"),"alt":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }